export enum BookingFlowType {
  RETAIL = 'RETAIL',
  INVENTORY = 'INVENTORY'
}
